// @flow

import React from 'react';

import Button from 'app/common/components/Button';
import ReasonsMessage from 'app/common/components/UpgradeInlineModal/ReasonsMessage';
import Modal, { ModalActions } from 'app/common/components/Modal';
import { WarningBar } from 'app/common/components/MessageBar';
import { connectedTrackModalOnMount } from 'app/common/components/TrackModalOnMount';

import type { Reason } from 'app/common/components/UpgradeInlineModal/types';

type Props = {
  reasons: Reason[],
  onCloseModal: () => void,
};

const UpgradeModal = (props: Props) => {
  return (
    <Modal
      closeOnEsc={true}
      closeOnOutsideClick={true}
      hideCloseButton={true}
      isOpened={true}
      onClose={props.onCloseModal}
    >
      <div className="dashboard-modal">
        <h1 className="dashboard-modal__title">Upgrade to Continue</h1>
        <WarningBar>
          Sorry, but there isn’t an available plan that will let you do that.
          Please contact our support team so we can assist you!
        </WarningBar>
        <p className="dashboard-modal__content">
          <ReasonsMessage reasons={props.reasons} />
        </p>
        <ModalActions>
          <Button
            kind="secondary large"
            onClick={props.onCloseModal}
            tag="Link"
          >
            Cancel
          </Button>
          <Button
            href="/app/contact-us"
            kind="primary large"
            onClick={props.onCloseModal}
            tag="Link"
          >
            Contact Us
          </Button>
        </ModalActions>
      </div>
    </Modal>
  );
};

export default connectedTrackModalOnMount(props => ({
  name: 'upgrade',
  reason: props.reasons.map(r => r.reason).join(','),
}))(UpgradeModal);
